import React from 'react';
import { Navigate } from 'react-router-dom';

import useAuthContext from '../hooks/useAuthContext';

interface Props {
  component: React.FC;
}

const ProtectedRoute: React.FC<Props> = ({ component: Component }) => {
  const { isLogged } = useAuthContext();

  if (isLogged) {
    return <Component />;
  }

  return <Navigate to="/" />;
};

export default ProtectedRoute;
